import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "./useAuth";
import { isEmailVerified } from "./useIsSsoUser";

export const useEmailVerify = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    if (!isEmailVerified(user)) {
      navigate("/auth/verify");
    }
  }, [navigate, user]);
};
